const Leaderboard = () => (
    <svg
        width='35'
        height='36'
        viewBox='0 0 35 36'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M32.8089 2.38609H28.8163V0.650163C28.8163 0.459212 28.6601 0.302979 28.4691 0.302979H6.24932C6.05837 0.302979 5.90214 0.459212 5.90214 0.650163V2.38609H1.90951C1.40308 2.38609 0.917387 2.58727 0.559284 2.94537C0.20118 3.30347 0 3.78916 0 4.2956V10.7185C0 14.2641 2.60388 17.2109 5.99761 17.749C6.67028 22.7919 10.7193 26.7628 15.7969 27.3183V31.8837H7.29087C6.52273 31.8837 5.90214 32.5043 5.90214 33.2725V34.6742C5.90214 34.8652 6.05837 35.0214 6.24932 35.0214H28.4691C28.6601 35.0214 28.8163 34.8652 28.8163 34.6742V33.2725C28.8163 32.5043 28.1957 31.8837 27.4276 31.8837H18.9216V27.3183C23.9991 26.7628 28.0482 22.7919 28.7208 17.749C32.1146 17.2109 34.7184 14.2641 34.7184 10.7185V4.2956C34.7184 3.78916 34.5173 3.30347 34.1592 2.94537C33.8011 2.58727 33.3154 2.38609 32.8089 2.38609ZM3.12466 10.7185V5.51075H5.90214V14.5202C5.096 14.2627 4.39255 13.7557 3.89332 13.0724C3.39409 12.3891 3.12492 11.5648 3.12466 10.7185V10.7185ZM25.6916 16.2735C25.6916 18.4043 24.8627 20.4136 23.3525 21.9195C21.8422 23.4298 19.8373 24.2587 17.7064 24.2587H17.012C14.8812 24.2587 12.8719 23.4298 11.366 21.9195C9.8557 20.4093 9.0268 18.4043 9.0268 16.2735V3.42764H25.6916V16.2735ZM31.5938 10.7185C31.5938 12.4978 30.4264 14.0081 28.8163 14.5202V5.51075H31.5938V10.7185Z'
            fill='url(#paint0_linear_1001_3556)'
        />
        <defs>
            <linearGradient
                id='paint0_linear_1001_3556'
                x1='0'
                y1='17.6622'
                x2='34.7184'
                y2='17.6622'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#00A6FF' />
                <stop offset='1' stopColor='#00FFFF' />
            </linearGradient>
        </defs>
    </svg>
);

export default Leaderboard;
